import { render, staticRenderFns } from "./UpdatePricePopup.vue?vue&type=template&id=55b06e22"
import script from "./UpdatePricePopup.vue?vue&type=script&lang=js"
export * from "./UpdatePricePopup.vue?vue&type=script&lang=js"
import style0 from "./UpdatePricePopup.vue?vue&type=style&index=0&id=55b06e22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports